import React from 'react';
import {FahrzeugType} from "../types/redux";

/**
 * Format an IBAN string into 4-piece blocks e.g. DE12 5001 0517 0648 4898 90
 * @param iban the IBAN string
 */
export const formatIban = (iban: string) => {
	const trimmedIban = iban.toUpperCase().replace(/[^A-Z0-9]/g, '');
	const ibanBlocks = trimmedIban.match(/.{1,4}/g);

	return ibanBlocks ? ibanBlocks.join(' ') : trimmedIban;
};

/**
 * Format a number in german currency style e.g. 15.000,00
 * @param price the price number
 */
export const formatPriceDe = (price: number) =>
	price?.toLocaleString(['DE'], { minimumFractionDigits: 2 });


export const formatterPrice = Intl.NumberFormat('de-DE', {
	style: 'currency',
	currency: 'EUR'
});
/**
 * transform date from YYYY-MM-DD to DD.MM.YYYY
 * @param dateEn the date string
 */
export const formatDateEn2De = (dateEn: string) =>
	dateEn.split('-').reverse().join('.');

export const formatVehicel = (ft: FahrzeugType) => {
	// console.log(" what is it: "  + ft)
	switch (ft) {
		case FahrzeugType.P: return ft + " (bis 3,5 Tonnen) ";
		case FahrzeugType.M: return ft + "";
		case FahrzeugType.W: return "Wohnwagen oder Wohnmobil (bis 7,5 Tonnen)";
	}
}
/**
 * Transforms a string to one or more ReactNodes. '\n' become <br /> tags
 * @param input the input string
 */
export const addLineBreaks = (input: string): React.ReactNode =>
	input.split('\n').map((text, index) => (
		<React.Fragment key={`${text}-${index}`}>
			{text}
			<br />
		</React.Fragment>
	));
